export default __webpack_public_path__ + "static/media/EmpyCart.e63a3b2b.jpg";